module.exports = __webpack_public_path__ + "img/9788958284864.7638cc47.jpg";